// import React, { useState, useEffect } from 'react';
// import CustomButton from "./CustomButton";
// let resolution = window.RESOLUTION;
// let tp = 80;
// let selectedBtnIndx = 0;
// if(window.innerWidth >= 1920 && window.innerHeight >= 1080){resolution = "FHD";}else{resolution = "HD";}
// const userAgent = navigator.userAgent.toLowerCase();
// if (userAgent.includes('webos') || userAgent.includes('lg') || userAgent.includes('web0s')) {
// resolution = 'FHD';
// }
// const ModalScreen = ({shouldShowError, errTitle, errDescription, errIcon, button, okaybtn, iconWdth, iconHeight, modalOKButtonHandler, modalCANCELButtonHandler}) => {
//   const [state, setState] = useState({
//     isOKSelected: true,
//     isCANCELSelected: false
//   });
//   const {isOKSelected, isCANCELSelected} = state;
//   console.log("Modal Screen.....", isOKSelected, isCANCELSelected);
//     const styles = {
//         ModalContainer: {
//           display: shouldShowError?'flex':'none',
//           flexDirection: 'column',
//           background: 'transparent',
//           width: '100vw',
//           height: '100vh',
//           backgroundSize: 'cover',
//           backgroundPosition: 'center', // Center the background image
//           backgroundRepeat: 'no-repeat', // Do not repeat the background image
//           overflow: 'hidden',
//           position: 'absolute'
//         },
//     };
//     useEffect(() => {
//       console.log("shouldShowError..11111111..", shouldShowError);
//       if(shouldShowError){
//         console.log("shouldShowError.....22222222....", shouldShowError);
//         window.addEventListener('keydown', ModalScreenKeyHandler)
//       }else{
//         window.removeEventListener("keydown", ModalScreenKeyHandler);
//       }
//       return () => {
//         window.removeEventListener("keydown", ModalScreenKeyHandler);
//       };
//     }, [shouldShowError]);
//     const ModalScreenKeyHandler = (event) => {
//         switch(event.keyCode){
//           case 40:
//             console.log("isOKSelected ---- = ", isOKSelected, selectedBtnIndx)
//             if(selectedBtnIndx === 0){
//               setState((prevState) => ({
//                 ...prevState,
//                 isOKSelected: false,
//                 isCANCELSelected: true,
//               }));
//               selectedBtnIndx += 1;
//             }
//             break;
//           case 38:
//             console.log("isCANCELSelected ---- = ", isCANCELSelected, selectedBtnIndx)
//             if(selectedBtnIndx === 1){
//               setState((prevState) => ({
//                 ...prevState,
//                 isOKSelected: true,
//                 isCANCELSelected: false,
//               }));
//               selectedBtnIndx -= 1;
//             }
//             break;
//           case 13:
//             window.removeEventListener("keydown", ModalScreenKeyHandler);
//             if(selectedBtnIndx === 0){
//               modalOKButtonHandler(button[0])
//             }else if(selectedBtnIndx === 1){
//               modalCANCELButtonHandler()
//             }
//             break;
//           default:
//             break;
//         }
//     };
//   return (
//     <div style={styles.ModalContainer}>
//       <div style={{overflow: 'hidden', width: '100vw', height: '100vh', position: 'absolute', background: '#000000', opacity: 0.7}}></div>
//       <div style={{overflow: 'hidden', position: 'absolute', width: '100vw', height:'30vh', background: '#181818', marginTop: '70vh', zIndex: '2'}}>
//         <div style={{overflow: 'hidden', display: 'flex', justifyContent: 'center',alignItems: 'center',width: '17vw', height: '30vh',
//                      position:'absolute', background:'#0E1653'}}>
//                       <img src={errIcon} style={{width: iconWdth, height: iconHeight}}/>
//         </div>
//         <div style={{overflow: 'hidden', display: 'flex', width: '50vw', height: '30vh',
//                      position:'absolute', background:'#0E1653', marginLeft: '17vw'}}>
//                       <div style={{position: 'absolute', fontSize: '32px', marginLeft: '50px', marginTop: '10vh', color: '#FFFFFF'}}>{errTitle}</div>
//                       <div style={{position: 'absolute', fontSize: '24px', marginLeft: '50px', marginTop: '15vh', color: '#FFFFFF'}}>{errDescription}</div>
//         </div>
//         <div style={{overflow: 'hidden', display: 'flex', width: '35vw', height: '30vh',
//                      position:'absolute', background:'#0E1653', marginLeft: '63vw'}}>

//                         <CustomButton fontSize={resolution === "FHD" ? "26px" : "18px"}
//                         defaultSelected={isOKSelected}
//                         width={resolution === "FHD" ? "600px" : "169px"}
//                         height={resolution === "FHD" ? "80px" : "53px"}
//                         top={resolution === "FHD" ? "80px" : "53px"}>
//                             {button[0]}
//                         </CustomButton>

//                         <CustomButton fontSize={resolution === "FHD" ? "26px" : "18px"}
//                         defaultSelected={isCANCELSelected}
//                         width={resolution === "FHD" ? "600px" : "169px"}
//                         height={resolution === "FHD" ? "80px" : "53px"}
//                         top={resolution === "FHD" ? "170px" : "53px"}>
//                             {button[1]}
//                         </CustomButton>

//         </div>
//       </div>
//     </div>
//   );
// };
// export default ModalScreen;

// import React, { useState, useEffect, useRef } from 'react';
// import CustomButton from "./CustomButton";
// import { Translate } from './LanguageChanger';
// import { setEventReminder, getComingSoon } from '../services/services';

// let resolution = window.RESOLUTION;
// let check_reminder_status = null;

// const ModalScreen = ({
//   shouldRemindPopup,
//   shouldShowError,
//   errTitle,
//   errDescription,
//   errIcon,
//   button,
//   iconWdth,
//   iconHeight,
//   modalOKButtonHandler,
//   modalCANCELButtonHandler,
//   remindPopup,
//   data
// }) => {
//   const [selectedBtnIndx, setSelectedBtnIndx] = useState(0);
//   const [isToggleOn, setIsToggleOn] = useState(false);
//   const toggleRef = useRef(null);

//   const styles = {
//     ModalContainer: {
//       display: shouldShowError || shouldRemindPopup ? 'flex' : 'none',
//       flexDirection: 'column',
//       background: 'transparent',
//       width: '100vw',
//       height: '100vh',
//       backgroundSize: 'cover',
//       backgroundPosition: 'center',
//       backgroundRepeat: 'no-repeat',
//       overflow: 'hidden',
//       position: 'absolute',
//       top: "0"
//     },
//   };

//   console.log("remindMeStatus...", data);

//   useEffect(() => {
//     checkAddedComing(data);
//     if (shouldShowError || shouldRemindPopup) {
//       window.addEventListener('keydown', ModalScreenKeyHandler);
//     }
//     return () => {
//       window.removeEventListener('keydown', ModalScreenKeyHandler);
//     };
//   }, [shouldShowError, shouldRemindPopup, selectedBtnIndx, isToggleOn]);

//   const ModalScreenKeyHandler = (event) => {
//     if (shouldShowError) {
//       handleErrorPopupKeys(event);
//     } else if (shouldRemindPopup) {
//       handleReminderPopupKeys(event);
//     }
//   };

//   const handleErrorPopupKeys = (event) => {
//     switch (event.keyCode) {
//       case 40: // Down arrow
//         if (selectedBtnIndx === 0) {
//           setSelectedBtnIndx(1);
//         }
//         break;
//       case 38: // Up arrow
//         if (selectedBtnIndx === 1) {
//           setSelectedBtnIndx(0);
//         }
//         break;
//       case 13: // Enter key
//         if (selectedBtnIndx === 0) {
//           modalOKButtonHandler(button[0]);
//         } else if (selectedBtnIndx === 1) {
//           modalCANCELButtonHandler();
//         }
//         break;
//       case 10009: // back key
//       case 461: // back key
//       case 8:
//         modalCANCELButtonHandler();
//         break;
//       default:
//         break;
//     }
//   };

//   const handleReminderPopupKeys = (event) => {
//     switch (event.keyCode) {
//       // case 37: // Left arrow
//       // case 39: // Right arrow
//       case 13: // Enter key
//         toggleToggle();
//         break;
//       case 10009: // back key
//       case 461: // back key
//       case 8:
//         remindPopup();
//         break;
//       default:
//         break;
//     }
//   };

//   const toggleToggle = () => {
//     setIsToggleOn(!isToggleOn);
//     console.log("isToggleOn...", isToggleOn);
//     // if (!isToggleOn) {
//       remindMe(data);
//     // }
//     // let setReminder = isToggleOn;
//     // window.SETREMINDER = isToggleOn;
//     // console.log("setReminder...", isToggleOn);
//   };

//   const handleOk = () => {
//     modalOKButtonHandler(button[0]);
//   };

//   const handleCancel = () => {
//     modalCANCELButtonHandler();
//   };

//   const remindMe = async (data) => {
//     console.log("firstEpisode.....", data);
//     const profile_id = localStorage.getItem("profileId");
//     console.log("2222222222222.......", data);

//     // if (!data) {
//     //   return;
//     // }

//     // if (!data.owned_by !== 0) {
//     //   return;
//     // }

//     // if (
//     //   data !== undefined &&
//     //   data.owned_by !== undefined &&
//     //   data.owned_by == 0
//     // ) {
//     try {
//       let remindMeStatus = null;
//       const headers = {
//         Version: localStorage.getItem("version"),

//         Deviceid: localStorage.getItem("macAddress"),
//         Devicetoken: localStorage.getItem("uuid"),
//         Devicemodel: localStorage.getItem("modelCode"),
//         Profileid: 1,
//         "Content-Type": "application/json",
//       };

//       const reminderStatus = check_reminder_status === 1 ? 0 : 1;

//       const postBody = {
//         profile_id: profile_id,
//         show_id: data.id,
//         reminder_status: reminderStatus,
//       };

//       remindMeStatus = await setEventReminder(JSON.stringify(postBody));

//       console.log("remindMeStatus...modal..", data, remindMeStatus.data);
//     } catch (error) {
//       console.log("4444444444..........", error);
//       // setState((prevState) => ({
//       //   ...prevState,
//       //   loading: false,
//       //   itemDetails: [data],
//       //   shouldShowToast: false,
//       //   toastMsg: "Playback error! Please try again later.",
//       //   toastBgColor: "red",
//       // }));
//     }
//     // }
//   };

//   const checkAddedComing = async (data) => {
//     console.log("checkAddedComing....");
//     const profile_id = localStorage.getItem("profileId");
//     const userId = localStorage.getItem("userId")
//     const showId = data?.id;

//      try {
//       let remindMeStatus = null;
//       const headers = {
//         Version: localStorage.getItem("version"),

//         Deviceid: localStorage.getItem("macAddress"),
//         Devicetoken: localStorage.getItem("uuid"),
//         Devicemodel: localStorage.getItem("modelCode"),
//         Profileid: 1,
//         "Content-Type": "application/json",
//       };

//       // const postBody = {
//       //   profile_id: profile_id,
//       //   show_id: data.video_id,
//       //   reminder_status: 0
//       // };

//       remindMeStatus = await getComingSoon(userId, showId);

//       check_reminder_status = remindMeStatus?.data?.reminder_status;

//       console.log("remindMeStatus...modal..", data, check_reminder_status);
//     } catch (error) {
//       console.log("4444444444..........", error);
//       // setState((prevState) => ({
//       //   ...prevState,
//       //   loading: false,
//       //   itemDetails: [data],
//       //   shouldShowToast: false,
//       //   toastMsg: "Playback error! Please try again later.",
//       //   toastBgColor: "red",
//       // }));
//     }

//   }

//   return (
//     <div style={styles.ModalContainer}>
//       {shouldShowError && (
//         <>
//           <div
//             style={{
//               overflow: 'hidden',
//               width: '100vw',
//               height: '100vh',
//               position: 'absolute',
//               background: '#000000',
//               opacity: 0.7,
//             }}
//           ></div>
//           <div
//             style={{
//               overflow: 'hidden',
//               position: 'absolute',
//               width: '100vw',
//               height: '30vh',
//               background: '#181818',
//               marginTop: '70vh',
//               zIndex: '2',
//             }}
//           >
//             <div
//               style={{
//                 overflow: 'hidden',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 width: '17vw',
//                 height: '30vh',
//                 position: 'absolute',
//                 background: '#0E1653',
//               }}
//             >
//               <img src={errIcon} style={{ width: iconWdth, height: iconHeight }} alt="Error" />
//             </div>
//             <div
//               style={{
//                 overflow: 'hidden',
//                 display: 'flex',
//                 width: '50vw',
//                 height: '30vh',
//                 position: 'absolute',
//                 background: '#0E1653',
//                 marginLeft: '17vw',
//               }}
//             >
//               <div
//                 style={{
//                   position: 'absolute',
//                   fontSize: '32px',
//                   marginLeft: '50px',
//                   marginTop: '10vh',
//                   color: '#FFFFFF',
//                 }}
//               >
//                 {typeof errTitle === "object" ? <><Translate langKey={errTitle.x} />{" " + errTitle.y} </> : <Translate langKey={errTitle} />}
//               </div>
//               <div
//                 style={{
//                   position: 'absolute',
//                   fontSize: '24px',
//                   marginLeft: '50px',
//                   marginTop: '15vh',
//                   color: '#FFFFFF',
//                 }}
//               >
//                 {typeof errDescription === "object" ? <> {errDescription.y}, <Translate langKey={errDescription.x} /></> : <Translate langKey={errDescription} />}
//               </div>
//             </div>
//             <div
//               style={{
//                 overflow: 'hidden',
//                 display: 'flex',
//                 width: '35vw',
//                 height: '30vh',
//                 position: 'absolute',
//                 background: '#0E1653',
//                 marginLeft: '63vw',
//               }}
//             >
//               <CustomButton
//                 fontSize={resolution === "FHD" ? "26px" : "18px"}
//                 defaultSelected={selectedBtnIndx === 0}
//                 width={resolution === "FHD" ? "600px" : "169px"}
//                 height={resolution === "FHD" ? "80px" : "53px"}
//                 top={resolution === "FHD" ? "80px" : "53px"}
//                 onClick={handleOk}
//               >
//                 <Translate langKey={button[0]} />
//               </CustomButton>

//               <CustomButton
//                 fontSize={resolution === "FHD" ? "26px" : "18px"}
//                 defaultSelected={selectedBtnIndx === 1}
//                 width={resolution === "FHD" ? "600px" : "169px"}
//                 height={resolution === "FHD" ? "80px" : "53px"}
//                 top={resolution === "FHD" ? "170px" : "53px"}
//                 onClick={handleCancel}
//               >
//                 <Translate langKey={button[1]} />
//               </CustomButton>
//             </div>
//           </div>
//         </>
//       )}

//       {shouldRemindPopup && (console.log("check_reminder_status....", check_reminder_status),
//         <>
//           <div
//             style={{
//               overflow: 'hidden',
//               width: '100vw',
//               height: '100vh',
//               position: 'absolute',
//               background: '#000000',
//               opacity: 0.7,
//             }}
//           ></div>
//           <div
//             style={{
//               width: "100vw",
//               height: "30vh",
//               backgroundColor: "#0E1653",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               padding: "0 40px",
//               boxSizing: "border-box",
//               position: "absolute",
//               bottom: 0,
//             }}
//           >
//             <div style={{ display: "flex", flexDirection: "column", color: "#FFFFFF" }}>
//               <span style={{ fontSize: "22px", fontWeight: "600" }}>Set Reminder</span>
//               <span style={{ fontSize: "16px", color: "#ccc", marginTop: "5px" }}>
//                 We'll alert you when it's released.
//               </span>
//               <span style={{ fontSize: "18px", marginTop: "10px", fontWeight: "bold" }}>
//                 RRR - 9th July 2025
//               </span>
//             </div>

//             <div>
//               <button
//                 ref={toggleRef}
//                 style={{
//                   width: "8vw",
//                   height: "5vh",
//                   backgroundColor: check_reminder_status === 1 ? "#D20082" : "#888",
//                   // backgroundColor: isToggleOn ? "#D20082" : "#888",
//                   borderRadius: "34px",
//                   border: "none",
//                   outline: "none",
//                   position: "relative",
//                   cursor: "pointer",
//                 }}
//               >
//                 <span
//                   style={{
//                     position: "absolute",
//                     height: "5vh",
//                     width: "3vw",
//                     // left: isToggleOn ? "calc(100% - 3vw)" : "0px",
//                     left: check_reminder_status === 1 ? "calc(100% - 3vw)" : "0px",
//                     bottom: "0",
//                     backgroundColor: "#fff",
//                     borderRadius: "50%",
//                     transition: ".3s ease",
//                   }}
//                 />
//               </button>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default ModalScreen;

// import React, { useState, useEffect, useRef } from "react";
// import CustomButton from "./CustomButton";
// import { Translate } from "./LanguageChanger";
// import { setEventReminder, getComingSoon } from "../services/services";
// import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
// import { QRCodeCanvas } from "qrcode.react";
// let resolution = window.RESOLUTION;

// const ModalScreen = ({
//   shouldRemindPopup,
//   shouldShowError,
//   shouldAuthError,
//   errTitle,
//   errDescription,
//   errIcon,
//   button,
//   iconWdth,
//   iconHeight,
//   modalOKButtonHandler,
//   modalCANCELButtonHandler,
//   remindPopup,
//   data,
// }) => {
//   const [selectedBtnIndx, setSelectedBtnIndx] = useState(0);
//   const [isToggleOn, setIsToggleOn] = useState(false);
//   const [reminderStatus, setReminderStatus] = useState(0); // Use state instead of global variable
//   const toggleRef = useRef(null);

//   const styles = {
//     ModalContainer: {
//       display: shouldShowError || shouldRemindPopup ? "flex" : "none",
//       flexDirection: "column",
//       background: "transparent",
//       width: "100vw",
//       height: "100vh",
//       backgroundSize: "cover",
//       backgroundPosition: "center",
//       backgroundRepeat: "no-repeat",
//       overflow: "hidden",
//       position: "absolute",
//       top: "0",
//        zIndex: "100",
     
//     },
//   };

//   useEffect(() => {
//     if (shouldRemindPopup && data?.id) {
//       checkAddedComing(data);
//     }

//     if (shouldShowError || shouldRemindPopup) {
//       window.addEventListener("keydown", ModalScreenKeyHandler);
//     }
//     return () => {
//       window.removeEventListener("keydown", ModalScreenKeyHandler);
//     };
//   }, [
//     shouldShowError,
//     shouldRemindPopup,
//     selectedBtnIndx,
//     isToggleOn,
//     reminderStatus,
//   ]);

//   const ModalScreenKeyHandler = (event) => {
//     if (shouldShowError) {
//       handleErrorPopupKeys(event);
//     } else if (shouldRemindPopup) {
//       handleReminderPopupKeys(event);
//     }
//   };

//   const handleErrorPopupKeys = (event) => {
//     switch (event.keyCode) {
//       case 40: // Down arrow
//         if (selectedBtnIndx === 0 && shouldShowError && !shouldAuthError) {
//           setSelectedBtnIndx(1);
//         }
//         break;
//       case 38: // Up arrow
//         if (selectedBtnIndx === 1) {
//           setSelectedBtnIndx(0);
//         }
//         break;
//       case 13: // Enter key
//       if( shouldShowError) {
//         if (selectedBtnIndx === 0) {
//           modalOKButtonHandler(button[0]);
//         } else if (selectedBtnIndx === 1) {
//           modalCANCELButtonHandler();
//         }
//       }else if(shouldAuthError){
//         if (selectedBtnIndx === 0) {
//           localStorage.clear();
//           modalOKButtonHandler(button[0]);
//         }
//       }
//         break;
//       case 10009: // back key
//       case 461: // back key
//       case 8:
//         modalCANCELButtonHandler();
//         break;
//       default:
//         break;
//     }
//   };

//   const handleReminderPopupKeys = (event) => {
//     switch (event.keyCode) {
//       case 13: // Enter key
//         toggleToggle();
//         break;
//       case 10009: // back key
//       case 461: // back key
//       case 8:
//         remindPopup();
//         break;
//       default:
//         break;
//     }
//   };

//   const toggleToggle = async () => {
//     try {
//       const newStatus = reminderStatus === 1 ? 0 : 1;
//       await remindMe(data, newStatus);
//       setReminderStatus(newStatus);
//       setIsToggleOn(!isToggleOn);
//       sendTestMatomoEvent({
//         eventCategory: "Coming Soon",
//         eventAction: "View",
//         eventName: "RemindMePopup",
//       });

//       if (newStatus === 1) {
//         sendTestMatomoEvent({
//           eventCategory: "RemindMePopup",
//           eventAction: "Select",
//           eventName: `Coming Soon${data?.id}/${data?.title}/Status(Enable)`,
//         });
//       } else if (newStatus === 0) {
//         sendTestMatomoEvent({
//           eventCategory: "RemindMePopup",
//           eventAction: "Select",
//           eventName: `Coming Soon${data?.id}/${data?.title}/Status(Disable)`,
//         });
//       }
//     } catch (error) {
//       console.error("Error toggling reminder:", error);
//     }
//   };

//   const handleOk = () => {
//     modalOKButtonHandler(button[0]);
//   };

//   const handleCancel = () => {
//     modalCANCELButtonHandler();
//   };

//   const remindMe = async (data, newStatus) => {
//     if (!data?.id) return;

//     try {
//       const profile_id = localStorage.getItem("profileId");
//       const headers = {
//         Version: localStorage.getItem("version"),
//         Deviceid: localStorage.getItem("macAddress"),
//         Devicetoken: localStorage.getItem("uuid"),
//         Devicemodel: localStorage.getItem("modelCode"),
//         Profileid: 1,
//         "Content-Type": "application/json",
//       };

//       const postBody = {
//         profile_id: profile_id,
//         show_id: data.id,
//         reminder_status: newStatus,
//       };

//       await setEventReminder(JSON.stringify(postBody));
//     } catch (error) {
//       console.error("Error setting reminder:", error);
//       throw error;
//     }
//   };

//   const checkAddedComing = async (data) => {
//     if (!data?.id) return;

//     try {
//       const profile_id = localStorage.getItem("profileId");
//       const userId = localStorage.getItem("userId");
//       const showId = data.id;

//       const headers = {
//         Version: localStorage.getItem("version"),
//         Deviceid: localStorage.getItem("macAddress"),
//         Devicetoken: localStorage.getItem("uuid"),
//         Devicemodel: localStorage.getItem("modelCode"),
//         Profileid: 1,
//         "Content-Type": "application/json",
//       };

//       const response = await getComingSoon(profile_id, showId);
//       const status = response?.data?.reminder_status || 0;
//       window.REMINDER_STATUS = status;
//       console.log("Alarm Reminder....", response, status);
//       setReminderStatus(status);
//       setIsToggleOn(status === 1);
//     } catch (error) {
//       console.error("Error checking reminder status:", error);
//     }
//   };

//   let remindMsg =
//     window.REMINDER_STATUS === 1
//       ? "We’ll remind you before the event starts"
//       : "Set Reminder";

//   const dateTime = data?.endtime ? data.endtime * 1000 : null;
//   const currentTime = dateTime ? new Date(dateTime) : null;

//   const options = {
//     weekday: "short",
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   };
//   const formattedDate = currentTime
//     ? currentTime.toLocaleDateString("en-GB", options)
//     : "Coming Soon";

//   console.log("currentTime..modal..", currentTime);

//   console.log("modalscreen...", data?.endtime, new Date(data?.endtime));

//   return (
//     <div style={styles.ModalContainer}>
//       {shouldShowError && (
//         <>
//           <div
//             style={{
//               overflow: "hidden",
//               width: "100vw",
//               height: "100vh",
//               position: "absolute",
//               background: "#000000",
//               opacity: 0.7,
//             }}
//           ></div>
//           <div
//             style={{
//               overflow: "hidden",
//               position: "absolute",
//               width: "100vw",
//               height: "30vh",
//               background: "#181818",
//               // marginTop: '70vh',
//               bottom: 0,
              
//             }}
//           >
//             <div
//               style={{
//                 overflow: "hidden",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 width: "17vw",
//                 height: "30vh",
//                 position: "absolute",
//                 background: "#0E1653",
//               }}
//             >
//               <img
//                 src={errIcon}
//                 style={{ width: iconWdth, height: iconHeight }}
//                 alt="Error"
//               />
//             </div>
//             <div
//               style={{
//                 overflow: "hidden",
//                 display: "flex",
//                 width: "50vw",
//                 height: "30vh",
//                 position: "absolute",
//                 background: "#0E1653",
//                 marginLeft: "17vw",
//               }}
//             >
//               <div
//                 style={{
//                   position: "absolute",
//                   fontSize: "32px",
//                   marginLeft: "50px",
//                   marginTop: "10vh",
//                   color: "#FFFFFF",
//                 }}
//               >
//                 {typeof errTitle === "object" ? (
//                   <>
//                     <Translate langKey={errTitle.x} />
//                     {" " + errTitle.y}{" "}
//                   </>
//                 ) : (
//                   <Translate langKey={errTitle} />
//                 )}
//               </div>
//               <div
//                 style={{
//                   position: "absolute",
//                   fontSize: "24px",
//                   marginLeft: "50px",
//                   marginTop: "15vh",
//                   color: "#FFFFFF",
//                 }}
//               >
//                 {typeof errDescription === "object" ? (
//                   <>
//                     {" "}
//                     {errDescription.y}, <Translate langKey={errDescription.x} />
//                   </>
//                 ) : (
//                   <Translate langKey={errDescription} />
//                 )}
//               </div>
//             </div>
//             {/* <div
//               style={{
//                 overflow: 'hidden',
//                 display: 'flex',
//                 width: '35vw',
//                 height: '30vh',
//                 position: 'absolute',
//                 background: '#0E1653',
//                 marginLeft: '63vw',
//               }}
//             >
//               <CustomButton
//                 fontSize={resolution === "FHD" ? "26px" : "18px"}
//                 defaultSelected={selectedBtnIndx === 0}
//                 width={resolution === "FHD" ? "600px" : "169px"}
//                 height={resolution === "FHD" ? "80px" : "53px"}
//                 top={resolution === "FHD" ? "80px" : "53px"}
//                 onClick={handleOk}
//               >
//                 <Translate langKey={button[0]} />
//               </CustomButton>

//               <CustomButton
//                 fontSize={resolution === "FHD" ? "26px" : "18px"}
//                 defaultSelected={selectedBtnIndx === 1}
//                 width={resolution === "FHD" ? "600px" : "169px"}
//                 height={resolution === "FHD" ? "80px" : "53px"}
//                 top={resolution === "FHD" ? "170px" : "53px"}
//                 onClick={handleCancel}
//               >
//                 <Translate langKey={button[1]} />
//               </CustomButton>
//             </div> */}
//             <div
//               style={{
//                 width: "35vw",
//                 height: "30vh",
//                 position: "absolute",
//                 background: "#0E1653",
//                 marginLeft: "63vw",
//                 display: "flex",
//                 flexDirection: "column", // Stack buttons vertically
//                 alignItems: "flex-end", // Align to right
//                 // padding: '20px', // Add some internal spacing
//                 padding: "70px", // Add some internal spacing
//                 boxSizing: "border-box", // Include padding in width/height
//               }}
//             >
//               <CustomButton
//                 fontSize={resolution === "FHD" ? "26px" : "18px"}
//                 defaultSelected={selectedBtnIndx === 0}
//                 height={resolution === "FHD" ? "80px" : "53px"}
//                 style={{
//                   width: "100%", // Use full container width
//                   marginBottom: "16px", // Space between buttons
//                   textAlign: "center", // Center button text
//                 }}
//                 onClick={handleOk}
//               >
//                 <Translate langKey={button[0]} />
//               </CustomButton>

//               <CustomButton
//                 fontSize={resolution === "FHD" ? "26px" : "18px"}
//                 defaultSelected={selectedBtnIndx === 1}
//                 height={resolution === "FHD" ? "80px" : "53px"}
//                 style={{
//                   width: "100%", // Use full container width
//                   textAlign: "center", // Center button text
//                 }}
//                 onClick={handleCancel}
//               >
//                 <Translate langKey={button[1]} />
//               </CustomButton>
//             </div>
//           </div>
//         </>
//       )}

//       {shouldAuthError && (
//         <>
//           <div
//             style={{
//               overflow: "hidden",
//               width: "100vw",
//               height: "100vh",
//               position: "absolute",
//               background: "#000000",
//               opacity: 0.7,
//             }}
//           ></div>
//           <div
//             style={{
//               overflow: "hidden",
//               position: "absolute",
//               width: "100vw",
//               height: "30vh",
//               background: "#181818",
//               // marginTop: '70vh',
//               bottom: 0,
//               zIndex: "2",
//             }}
//           >
//             <div
//               style={{
//                 overflow: "hidden",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 width: "17vw",
//                 height: "30vh",
//                 position: "absolute",
//                 background: "#0E1653",
//               }}
//             >
//               <img
//                 src={errIcon}
//                 style={{ width: iconWdth, height: iconHeight }}
//                 alt="Error"
//               />
//             </div>
//             <div
//               style={{
//                 overflow: "hidden",
//                 display: "flex",
//                 width: "50vw",
//                 height: "30vh",
//                 position: "absolute",
//                 background: "#0E1653",
//                 marginLeft: "17vw",
//               }}
//             >
//               <div
//                 style={{
//                   position: "absolute",
//                   fontSize: "32px",
//                   marginLeft: "50px",
//                   marginTop: "10vh",
//                   color: "#FFFFFF",
//                 }}
//               >
//                 {typeof errTitle === "object" ? (
//                   <>
//                     <Translate langKey={errTitle.x} />
//                     {" " + errTitle.y}{" "}
//                   </>
//                 ) : (
//                   <Translate langKey={errTitle} />
//                 )}
//               </div>
//               <div
//                 style={{
//                   position: "absolute",
//                   fontSize: "24px",
//                   marginLeft: "50px",
//                   marginTop: "15vh",
//                   color: "#FFFFFF",
//                 }}
//               >
//                 {typeof errDescription === "object" ? (
//                   <>
//                     {" "}
//                     {errDescription.y}, <Translate langKey={errDescription.x} />
//                   </>
//                 ) : (
//                   <Translate langKey={errDescription} />
//                 )}
//               </div>
//             </div>
//             {/* <div
//               style={{
//                 overflow: 'hidden',
//                 display: 'flex',
//                 width: '35vw',
//                 height: '30vh',
//                 position: 'absolute',
//                 background: '#0E1653',
//                 marginLeft: '63vw',
//               }}
//             >
//               <CustomButton
//                 fontSize={resolution === "FHD" ? "26px" : "18px"}
//                 defaultSelected={selectedBtnIndx === 0}
//                 width={resolution === "FHD" ? "600px" : "169px"}
//                 height={resolution === "FHD" ? "80px" : "53px"}
//                 top={resolution === "FHD" ? "80px" : "53px"}
//                 onClick={handleOk}
//               >
//                 <Translate langKey={button[0]} />
//               </CustomButton>

//               <CustomButton
//                 fontSize={resolution === "FHD" ? "26px" : "18px"}
//                 defaultSelected={selectedBtnIndx === 1}
//                 width={resolution === "FHD" ? "600px" : "169px"}
//                 height={resolution === "FHD" ? "80px" : "53px"}
//                 top={resolution === "FHD" ? "170px" : "53px"}
//                 onClick={handleCancel}
//               >
//                 <Translate langKey={button[1]} />
//               </CustomButton>
//             </div> */}
//             <div
//               style={{
//                 width: "35vw",
//                 height: "30vh",
//                 position: "absolute",
//                 background: "#0E1653",
//                 marginLeft: "63vw",
//                 display: "flex",
//                 flexDirection: "column", // Stack buttons vertically
//                 alignItems: "flex-end", // Align to right
//                 // padding: '20px', // Add some internal spacing
//                 padding: "70px", // Add some internal spacing
//                 boxSizing: "border-box", // Include padding in width/height
//               }}
//             >
//               <CustomButton
//                 fontSize={resolution === "FHD" ? "26px" : "18px"}
//                 defaultSelected={selectedBtnIndx === 0}
//                 height={resolution === "FHD" ? "80px" : "53px"}
//                 style={{
//                   width: "100%", // Use full container width
//                   marginBottom: "16px", // Space between buttons
//                   textAlign: "center", // Center button text
//                   position: "relative", // Ensure button is positioned correctly
//                   top: "3rem", // Center vertically
//                 }}
//                 onClick={handleOk}
//               >
//                 <Translate langKey={button[0]} />
//               </CustomButton>
//             </div>
//           </div>
//         </>
//       )}

//       {shouldRemindPopup && (
//         <>
//           <div
//             style={{
//               overflow: "hidden",
//               width: "100vw",
//               height: "100vh",
//               position: "absolute",
//               background: "#000000",
//               opacity: 0.7,
//             }}
//           ></div>
//           <div
//             style={{
//               width: "100vw",
//               height: "30vh",
//               backgroundColor: "#0E1653",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               padding: "0 40px",
//               boxSizing: "border-box",
//               position: "absolute",
//               bottom: 0,
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 color: "#FFFFFF",
//               }}
//             >
//               {/* <span style={{ fontSize: "22px", fontWeight: "600" }}>Set Reminder</span> */}
//               <span
//                 style={{ fontSize: "2rem", color: "#ccc", marginTop: "5px" }}
//               >
//                 {remindMsg}
//                 {/* We’ll remind you before the event starts" */}
//               </span>
//               <span
//                 style={{
//                   fontSize: "18px",
//                   marginTop: "10px",
//                   fontWeight: "bold",
//                 }}
//               >
//                 {`${data?.title || "Show"} - ${formattedDate}`}
//                 {/* {(data?.title || 'Show') + ' - ' + (currentTime ? currentTime : 'Coming Soon')} */}
//                 {/* {data?.title || 'Show'} - {((new Date(data?.endtime)) * 1000) || 'Coming Soon'} */}
//               </span>
//             </div>

//             <div>
//               <button
//                 ref={toggleRef}
//                 style={{
//                   width: "8vw",
//                   height: "4vh",
//                   backgroundColor: reminderStatus === 1 ? "#D20082" : "#888",
//                   borderRadius: "34px",
//                   border: "none",
//                   outline: "none",
//                   position: "relative",
//                   cursor: "pointer",
//                   // boxShadow: "0px 4px 10px rgba(210, 0, 130, 0.6)",
//                   boxShadow: "rgba(210, 50, 130, 0.4) 23px 24px 49px 16px",
//                   transition: "background-color 0.3s ease",
//                 }}
//                 onClick={toggleToggle}
//               >
//                 <span
//                   style={{
//                     position: "absolute",
//                     height: "5vh",
//                     width: "3vw",
//                     left: reminderStatus === 1 ? "calc(100% - 3vw)" : "0px",
//                     // bottom: "0",
//                     top: "-5px",
//                     backgroundColor: "#fff",
//                     borderRadius: "50%",
//                     transition: ".3s ease",
//                   }}
//                 />
//               </button>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default ModalScreen;



import React, { useState, useEffect, useRef } from "react";
import CustomButton from "./CustomButton";
import { Translate } from "./LanguageChanger";
import { setEventReminder, getComingSoon } from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import { QRCodeCanvas } from "qrcode.react";


let resolution = window.RESOLUTION;

const ModalScreen = ({
  shouldRemindPopup,
  shouldShowError,
  shouldAuthError,
  errTitle,
  errDescription,
  errIcon,
  button,
  iconWdth,
  iconHeight,
  modalOKButtonHandler,
  modalCANCELButtonHandler,
  remindPopup,
  showLogoutModal,
  data,
  premiumQr,
}) => {
  const [selectedBtnIndx, setSelectedBtnIndx] = useState(0);
  const [isToggleOn, setIsToggleOn] = useState(false);
  const [reminderStatus, setReminderStatus] = useState(0); // Use state instead of global variable
  const toggleRef = useRef(null);

  const styles = {
    ModalContainer: {
      display: shouldShowError || shouldRemindPopup ? "flex" : "none",
      flexDirection: "column",
      background: "transparent",
      width: "100vw",
      height: "100vh",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      overflow: "hidden",
      position: "absolute",
      top: "0",
      zIndex: 100,
    },
  };

  useEffect(() => {
    if (shouldRemindPopup && data?.id) {
      checkAddedComing(data);
    }

    if (shouldShowError || shouldRemindPopup) {
      window.addEventListener("keydown", ModalScreenKeyHandler);
    }
    return () => {
      window.removeEventListener("keydown", ModalScreenKeyHandler);
    };
  }, [
    shouldShowError,
    shouldRemindPopup,
    selectedBtnIndx,
    isToggleOn,
    reminderStatus,
  ]);

  console.log("remindMeStatus...", data, showLogoutModal);

  const ModalScreenKeyHandler = (event) => {
    if (shouldShowError) {
      handleErrorPopupKeys(event);
    } else if (shouldRemindPopup) {
      handleReminderPopupKeys(event);
    }
  };

  const handleErrorPopupKeys = (event) => {
    switch (event.keyCode) {
      case 40: // Down arrow
        if (selectedBtnIndx === 0 && shouldShowError && !shouldAuthError) {
          setSelectedBtnIndx(1);
        }
        break;
      case 38: // Up arrow
        if (selectedBtnIndx === 1) {
          setSelectedBtnIndx(0);
        }
        break;
      case 13: // Enter key
      console.log("selectedBtnIndx...", showLogoutModal);
        if (shouldShowError) {
          if (selectedBtnIndx === 0) {
            modalOKButtonHandler(button[0]);
          } else if (selectedBtnIndx === 1) {
            modalCANCELButtonHandler();
          }
        } else if (shouldAuthError) {
          if (selectedBtnIndx === 0) {
            localStorage.clear();
            window.appReload();
            modalOKButtonHandler(button[0]);
          }
        }
        break;
      case 10009: // back key
      case 461: // back key
      case 8:
        if (shouldAuthError) return;
        modalCANCELButtonHandler();
        break;
      default:
        break;
    }
  };

  const handleReminderPopupKeys = (event) => {
    switch (event.keyCode) {
      case 13: // Enter key
        toggleToggle();
        break;
      case 10009: // back key
      case 461: // back key
      case 8:
        remindPopup();
        break;
      default:
        break;
    }
  };

  const toggleToggle = async () => {
    try {
      const newStatus = reminderStatus === 1 ? 0 : 1;
      await remindMe(data, newStatus);
      setReminderStatus(newStatus);
      setIsToggleOn(!isToggleOn);
      sendTestMatomoEvent({
        eventCategory: "Coming Soon",
        eventAction: "View",
        eventName: "RemindMePopup",
      });

      if (newStatus === 1) {
        sendTestMatomoEvent({
          eventCategory: "RemindMePopup",
          eventAction: "Select",
          eventName: `Coming Soon${data?.id}/${data?.title}/Status(Enable)`,
        });
      } else if (newStatus === 0) {
        sendTestMatomoEvent({
          eventCategory: "RemindMePopup",
          eventAction: "Select",
          eventName: `Coming Soon${data?.id}/${data?.title}/Status(Disable)`,
        });
      }
    } catch (error) {
      console.error("Error toggling reminder:", error);
    }
  };

  const handleOk = () => {
    localStorage.removeItem("NewmobileNo")
    modalOKButtonHandler(button[0]);
  };

  const handleCancel = () => {
    modalCANCELButtonHandler();
  };

  const remindMe = async (data, newStatus) => {
    if (!data?.id) return;

    try {
      const profile_id = localStorage.getItem("profileId");
      const headers = {
        Version: localStorage.getItem("version"),
        Deviceid: localStorage.getItem("macAddress"),
        Devicetoken: localStorage.getItem("uuid"),
        Devicemodel: localStorage.getItem("modelCode"),
        Profileid: 1,
        "Content-Type": "application/json",
      };

      const postBody = {
        profile_id: profile_id,
        show_id: data.id,
        reminder_status: newStatus,
      };

      await setEventReminder(JSON.stringify(postBody));
    } catch (error) {
      console.error("Error setting reminder:", error);
      throw error;
    }
  };

  const checkAddedComing = async (data) => {
    if (!data?.id) return;

    try {
      const profile_id = localStorage.getItem("profileId");
      const userId = localStorage.getItem("userId");
      const showId = data.id;

      const headers = {
        Version: localStorage.getItem("version"),
        Deviceid: localStorage.getItem("macAddress"),
        Devicetoken: localStorage.getItem("uuid"),
        Devicemodel: localStorage.getItem("modelCode"),
        Profileid: 1,
        "Content-Type": "application/json",
      };

      const response = await getComingSoon(profile_id, showId);
      const status = response?.data?.reminder_status || 0;
      window.REMINDER_STATUS = status;
      console.log("Alarm Reminder....", response, status);
      setReminderStatus(status);
      setIsToggleOn(status === 1);
    } catch (error) {
      console.error("Error checking reminder status:", error);
    }
  };

  let remindMsg =
    window.REMINDER_STATUS === 1
      ? "We’ll alert you before the event starts"
      : "Set Reminder";

  const dateTime = data?.endtime ? data.endtime * 1000 : null;
  const currentTime = dateTime ? new Date(dateTime) : null;

  const date = currentTime;

const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const months = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

const formattedDate = currentTime ?`${weekdays[date.getDay()]}, ${String(
  date.getDate()
).padStart(2, "0")} ${months[date.getMonth()]} ${date.getFullYear()}` : "Coming Soon";


  // const options = {
  //   weekday: "short",
  //   day: "2-digit",
  //   month: "short",
  //   year: "numeric",
  // };
  // const formattedDate = currentTime
  //   ? currentTime.toLocaleDateString("en-GB", options)
  //   : "Coming Soon";

  console.log("currentTime..modal..", currentTime,shouldAuthError);

  console.log("modalscreen...12", data?.endtime, new Date(data?.endtime));

  return (
    <div style={styles.ModalContainer}>
      {shouldShowError && (
        <>
          <div
            style={{
              overflow: "hidden",
              width: "100vw",
              height: "100vh",
              position: "absolute",
              background: "#000000",
              opacity: 0.7,
            }}
          ></div>
          <div
            style={{
              overflow: "hidden",
              position: "absolute",
              width: "100vw",
              height: "30vh",
              background: "#181818",
              // marginTop: '70vh',
              bottom: 0,
              zIndex: "2",
            }}
          >
            <div
              style={{
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "17vw",
                height: "30vh",
                position: "absolute",
                background: "#0E1653",
              }}
            >
              {errIcon ? (
                <img
                  src={errIcon}
                  style={{ width: iconWdth, height: iconHeight }}
                  alt="Error"
                />) :
                <QRCodeCanvas
                  value={premiumQr}
                  size={180}          // size in px
                  bgColor="#ffffff"
                  fgColor="#000000"
                  level="H"          // error correction level (L, M, Q, H)
                  includeMargin={true}
                />}
            </div>
            <div
              style={{
                overflow: "hidden",
                display: "flex",
                width: "50vw",
                height: "30vh",
                position: "absolute",
                background: "#0E1653",
                marginLeft: "17vw",
              }}
            >
              
              {/* Display errTitle for back-to-login case */}
              {errDescription === "back-to-login" &&  (
                <div
                  style={{
                    position: "absolute",
                    fontSize: "38px",
                    weight : 500,
                    marginLeft: "20px",
                    marginTop: "8vh",
                    color: "#FFFFFF",
                  }}
                >
                  {errTitle}
                </div>
              )}
              <div
                style={{
                  position: "relative",
                  top: errDescription === "back-to-login" ? "1vh" : "-2vh",
                  right: "2vw",
                  fontSize: "2rem",
                  marginLeft: "50px",
                  marginTop: "15vh",
                  color: "#FFFFFF",
                }}
              >
                {typeof errDescription === "object" ? (
                  <>
                    {errDescription.y}, <Translate langKey={errDescription.x} />
                  </>
                ) : (
                  <>
                    {errTitle === "Delete-Profile" ? (
                      <>
                        <Translate langKey={errDescription} />{" ' "}
                        {JSON.parse(localStorage.getItem("DeleteProfile"))?.name || "Unknown"}{" ' "}
                        <Translate langKey={"delete_conform"} />
                      </>
                    ) : errDescription === "back-to-login" ? (
                      <Translate langKey={errDescription} />
                    ) : (
                      <Translate langKey={errDescription} />
                    )}
                  </>
                )}
              </div>
            </div>
            {/* <div
              style={{
                overflow: 'hidden',
                display: 'flex',
                width: '35vw',
                height: '30vh',
                position: 'absolute',
                background: '#0E1653',
                marginLeft: '63vw',
              }}
            >
              <CustomButton
                fontSize={resolution === "FHD" ? "26px" : "18px"}
                defaultSelected={selectedBtnIndx === 0}
                width={resolution === "FHD" ? "600px" : "169px"}
                height={resolution === "FHD" ? "80px" : "53px"}
                top={resolution === "FHD" ? "80px" : "53px"}
                onClick={handleOk}
              >
                <Translate langKey={button[0]} />
              </CustomButton>

              <CustomButton
                fontSize={resolution === "FHD" ? "26px" : "18px"}
                defaultSelected={selectedBtnIndx === 1}
                width={resolution === "FHD" ? "600px" : "169px"}
                height={resolution === "FHD" ? "80px" : "53px"}
                top={resolution === "FHD" ? "170px" : "53px"}
                onClick={handleCancel}
              >
                <Translate langKey={button[1]} />
              </CustomButton>
            </div> */}
            <div
              style={{
                width: "35vw",
                height: "30vh",
                position: "absolute",
                background: "#0E1653",
                marginLeft: "65vw",
                display: "flex",
                flexDirection: "column", // Stack buttons vertically
                alignItems: "flex-end", // Align to right
                // padding: '20px', // Add some internal spacing
                padding: "70px", // Add some internal spacing
                boxSizing: "border-box", // Include padding in width/height
              }}
            >
              {/* <CustomButton
                fontSize={resolution === "FHD" ? "26px" : "18px"}
                defaultSelected={selectedBtnIndx === 0}
                height={resolution === "FHD" ? "80px" : "53px"}
                style={{
                  width: "100%", // Use full container width
                  marginBottom: "16px", // Space between buttons
                  textAlign: "center", // Center button text
                }}
                onClick={handleOk}
              >
                 {
                 errDescription == "cofirm-logout"? <Translate langKey={"Yes"} />: <Translate langKey={button[0]} />
                } 
              </CustomButton>
   */}

              <div
                onMouseEnter={() => {
                  setSelectedBtnIndx(0)
                }}
                // onMouseLeave={() => {
                //    setSelectedBtnIndx("");
                // }}
                fontSize={resolution === "FHD" ? "26px" : "18px"}
                // defaultSelected={selectedBtnIndx === 0}
                // height={resolution === "FHD" ? "80px" : "53px"}
                style={{
                  width: "100%",
                  height: resolution === "FHD" ? "66px" : "53px",
                  display: "flex",              // ✅ Use flexbox
                  alignItems: "center",         // ✅ Vertically center text
                  justifyContent: "center",     // ✅ Horizontally center text
                  borderRadius: "10px",
                  color: "#fff",
                  backgroundColor: selectedBtnIndx === 0 ? "#EC008C" : "",
                  fontSize: resolution === "FHD" ? "18px" : "15px",
                }}

                onClick={handleOk}
              >
                {
                  errDescription === "cofirm-logout" || errDescription === "back-to-login" ? 
                    <Translate langKey={"Yes"} /> : 
                    <Translate langKey={button[0]} />
                }
              </div>
              <div
                onMouseEnter={() => {
                  setSelectedBtnIndx(1)
                }}

                fontSize={resolution === "FHD" ? "26px" : "18px"}
                // defaultSelected={selectedBtnIndx === 0}
                // height={resolution === "FHD" ? "80px" : "53px"}
                style={{
                  width: "100%",
                  height: resolution === "FHD" ? "66px" : "53px",
                  display: "flex",              // ✅ Use flexbox
                  alignItems: "center",         // ✅ Vertically center text
                  justifyContent: "center",     // ✅ Horizontally center text
                  borderRadius: "10px",
                  color: "#fff",
                  backgroundColor: selectedBtnIndx === 1 ? "#EC008C" : "",
                  fontSize: resolution === "FHD" ? "18px" : "15px",
                }}

                onClick={handleCancel}
              >
                {
                  errDescription === "cofirm-logout" || errDescription === "back-to-login" ? 
                    <Translate langKey={"No"} /> : 
                    <Translate langKey={button[1]} />
                }


              </div>
              {/* <CustomButton
                fontSize={resolution === "FHD" ? "26px" : "18px"}
                defaultSelected={selectedBtnIndx === 1}
                height={resolution === "FHD" ? "80px" : "53px"}
                style={{
                  width: "100%", // Use full container width
                  textAlign: "center", // Center button text
                }}
                onClick={handleCancel}
              >
                 {
                errDescription == "cofirm-logout"? <Translate langKey={"No"} />: <Translate langKey={button[1]} />
                } 

              </CustomButton> */}
            </div>
          </div>
        </>
      )}

      {shouldAuthError && (
        <>
          <div
            style={{
              overflow: "hidden",
              width: "100vw",
              height: "100vh",
              position: "absolute",
              background: "#000000",
              opacity: 0.7,
            }}
          ></div>
          <div
            style={{
              overflow: "hidden",
              position: "absolute",
              width: "100vw",
              height: "30vh",
              background: "#181818",
              // marginTop: '70vh',
              bottom: 0,
              zIndex: "2",
            }}
          >
            <div
              style={{
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "17vw",
                height: "30vh",
                position: "absolute",
                background: "#0E1653",
              }}
            >
              <img
                src={errIcon}
                style={{ width: iconWdth, height: iconHeight }}
                alt="Error"
              />
            </div>
            <div
              style={{
                overflow: "hidden",
                display: "flex",
                width: "50vw",
                height: "30vh",
                position: "absolute",
                background: "#0E1653",
                marginLeft: "17vw",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  fontSize: "32px",
                  marginLeft: "50px",
                  marginTop: "10vh",
                  color: "#FFFFFF",
                }}
              >
                {typeof errTitle === "object" ? (
                  <>
                    <Translate langKey={errTitle.x} />
                    {" " + errTitle.y}{" "}
                  </>
                ) : (
                  <Translate langKey={errTitle} />
                )}
              </div>
              <div
                 style={{
    position: "absolute",
    fontSize:
      shouldAuthError && errDescription === "session-desc"
        ? "38px"
        : "24px",
    fontWeight:
      shouldAuthError && errDescription === "session-desc"
        ? 500
        : "normal",
    marginLeft:
      shouldAuthError && errDescription === "session-desc"
        ? "20px"
        : "50px",
    marginTop:
      shouldAuthError && errDescription === "session-desc"
        ? "12vh"
        : "15vh",
    color: "#FFFFFF",
      }}
              >
                {typeof errDescription === "object" ? (
                  <>
                    {" "}
                    {errDescription.y}, <Translate langKey={errDescription.x} />
                  </>
                ) : (
                  <Translate langKey={errDescription} />
                )}
              </div>
            </div>
            {/* <div
              style={{
                overflow: 'hidden',
                display: 'flex',
                width: '35vw',
                height: '30vh',
                position: 'absolute',
                background: '#0E1653',
                marginLeft: '63vw',
              }}
            >
              <CustomButton
                fontSize={resolution === "FHD" ? "26px" : "18px"}
                defaultSelected={selectedBtnIndx === 0}
                width={resolution === "FHD" ? "600px" : "169px"}
                height={resolution === "FHD" ? "80px" : "53px"}
                top={resolution === "FHD" ? "80px" : "53px"}
                onClick={handleOk}
              >
                <Translate langKey={button[0]} />
              </CustomButton>

              <CustomButton
                fontSize={resolution === "FHD" ? "26px" : "18px"}
                defaultSelected={selectedBtnIndx === 1}
                width={resolution === "FHD" ? "600px" : "169px"}
                height={resolution === "FHD" ? "80px" : "53px"}
                top={resolution === "FHD" ? "170px" : "53px"}
                onClick={handleCancel}
              >
                <Translate langKey={button[1]} />
              </CustomButton>
            </div> */}
            <div
              style={{
                width: "35vw",
                height: "30vh",
                position: "absolute",
                background: "#0E1653",
                marginLeft: "63vw",
                display: "flex",
                flexDirection: "column", // Stack buttons vertically
                alignItems: "flex-end", // Align to right
                // padding: '20px', // Add some internal spacing
                padding: "70px", // Add some internal spacing
                boxSizing: "border-box", // Include padding in width/height
              }}
            >
              <CustomButton
                fontSize={resolution === "FHD" ? "26px" : "18px"}
                defaultSelected={selectedBtnIndx === 0}
                height={resolution === "FHD" ? "80px" : "53px"}
                style={{
                  width: "100%", // Use full container width
                  marginBottom: "16px", // Space between buttons
                  textAlign: "center", // Center button text
                  position: "relative", // Ensure button is positioned correctly
                  top: "3rem", // Center vertically
                }}
                onClick={handleOk}
              >
                <Translate langKey={button[0]} />
              </CustomButton>
            </div>
          </div>
        </>
      )}

      {shouldRemindPopup && (
        <>
          <div
            style={{
              overflow: "hidden",
              width: "100vw",
              height: "100vh",
              position: "absolute",
              background: "#000000",
              opacity: 0.7,
            }}
          ></div>
          <div
            style={{
              width: "100vw",
              height: "30vh",
              backgroundColor: "#0E1653",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 80px",
              boxSizing: "border-box",
              position: "absolute",
              bottom: 0,
            }}
          >
            {/* <div
              style={{
                display: "flex",
                flexDirection: "column",
                color: "#FFFFFF",
              }}
            >
              <span
                style={{ fontSize: "2rem", color: "#ccc", marginTop: "5px" }}
              >
                {remindMsg}
              </span>
              <span
                style={{
                  fontSize: "18px",
                  marginTop: "10px",
                  fontWeight: "bold",
                }}
              >
                {`${data?.title || "Show"} - ${formattedDate}`}
              </span>
            </div> */}
              <div
              style={{
                display: "flex",
                flexDirection: "column",
                color: "#FFFFFF",
              }}
            >
              <span style={{ fontSize: "32px", fontWeight: "500" }}>Set Reminder</span>
              <span
                style={{ fontSize: "24px", color: "#ccc", marginTop: "10px" }}
              >
                {/* {remindMsg} */}
                We’ll remind you before the event starts
              </span>
              <span
                style={{
                  fontSize: "28px",
                  marginTop: "20px",
                  fontWeight: "500",
                }}
              >
                {`${data?.title || "Show"} - ${formattedDate}`}
                {/* {(data?.title || 'Show') + ' - ' + (currentTime ? currentTime : 'Coming Soon')} */}
                {/* {data?.title || 'Show'} - {((new Date(data?.endtime)) * 1000) || 'Coming Soon'} */}
              </span>
            </div>
 
 

            <div>
              <button
                ref={toggleRef}
                style={{
                  width: "8vw",
                  height: "4vh",
                  backgroundColor: reminderStatus === 1 ? "#D20082" : "#888",
                  borderRadius: "34px",
                  border: "none",
                  outline: "none",
                  position: "relative",
                  cursor: "pointer",
                  // boxShadow: "0px 4px 10px rgba(210, 0, 130, 0.6)",
                  boxShadow: "rgba(210, 50, 130, 0.4) 23px 24px 49px 16px",
                  transition: "background-color 0.3s ease",
                }}
                onClick={toggleToggle}
              >
                <span
                  style={{
                    position: "absolute",
                    height: "5vh",
                    width: "3vw",
                    left: reminderStatus === 1 ? "calc(100% - 3vw)" : "0px",
                    // bottom: "0",
                    top: "-5px",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    transition: ".3s ease",
                  }}
                />
              </button>
            </div>
          </div>
        </>
      )}
      
    </div>
  );
};

export default ModalScreen;